import React from 'react';

import styles from './skill.module.css';
import Icon from './Icon';

const SkillCat = ({title, icon, text}) => {
  return (
    <div className={styles.skillCardWrapper}>
      <div className={styles.skillCardHeading}>

        <div className={styles.skillCardIcon}>
          <Icon type={icon} />
        </div>

        <div className={styles.skillCardTitle}>
          {title}
        </div>

      </div>

      <div className={styles.skillCardText}>
        {text}
      </div>



    </div>
  )
}

export default SkillCat;